import React from 'react';

const FormContainer = ({
  title,
  onClose,
  onSave,
  onCancel,
  saveText = 'Save',
  cancelText = 'Cancel',
  saving = false,
  children
}) => {
  return (
    <div className="form-container-card">
      {/* Fixed Header */}
      <header className="form-container-header">
        <div className="form-container-title-group">
          {onClose && (
            <button
              type="button"
              className="form-container-back-btn"
              onClick={onClose}
              aria-label="Back"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
            </button>
          )}
          <h2 className="form-container-title">{title}</h2>
        </div>
        {onClose && (
          <button
            type="button"
            className="form-container-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        )}
      </header>

      {/* Middle Scrollable Content */}
      <div className="form-container-body">
        {children}
      </div>

      {/* Fixed Footer */}
      <footer className="form-container-footer">
        <button
          type="button"
          className="btn-cancel"
          onClick={onCancel || onClose}
          disabled={saving}
        >
          {cancelText}
        </button>
        <button
          type="button"
          className="submit-btn"
          style={{ maxWidth: '180px' }}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : `💾 ${saveText}`}
        </button>
      </footer>
    </div>
  );
};

export default FormContainer;
